/**
 * @author HungNS
 */
import FactoryService from '@/services/FactoryService.js'
import * as TYPE from './type'
import IConstants from '@/common/constants/IConstants'
import ServiceUtils from '@/common/utils/ServiceUtils'
import i18n from '@/lang/i18n'
import {find, findIndex, floor, isEmpty, isNil} from 'lodash'
import Vue from 'vue'
import {isNumber} from '@/common/helpers/store';

const forceNewsService = FactoryService.getService('forceNews');
const listFinalAssets = IConstants.listFinalAssets;

/* eslint-disable no-unused-vars */

const moduleNews = {
    namespaced: true,
    state: () => ({
        systemCache: null,
        customerInfoResponse: null,
        customerInfoView: null,
        formName: 'edit_individual',
        isCorporation: false,

        inputArr: [],

        hasAdditionEmail: false,
        enableGoogleAuthFlag: false,
        disableGoogleAuthFlag: false,
        showVerifyCode: false,

        SUPPORT_DOCUMENT_URL: '',
        SUPPORT_DOMINATOR_URL: '',
        SUPPORT_FORM_URL: '',
        NEW_UPLOAD_DOCUMENT_URL: '',

        remainForceNewsList:[]


    }),
    mutations: {
        [TYPE.SET_SYSTEM_CACHE](state, payload) {
            state.systemCache = {...payload};
        },

        [TYPE.SET_AMS_CUSTOMER_INFO](state, payload) {
            initInput(state, payload);
        },

        [TYPE.VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS](state, payload) {
            validateSelfAssetAndBoMaxLoss(state, payload.messageId)
        },
        [TYPE.SET_REMAIN_FORCE_NEWS_LIST](state, payload){
            state.remainForceNewsList = payload
        }

    },
    actions: {
        async [TYPE.GET_SYSTEM_CACHE]({commit}) {
            const data = await forceNewsService.loadSystemCache();
            commit(TYPE.SET_SYSTEM_CACHE, data)
        },
        async [TYPE.GET_AMS_CUSTOMER_INFO]({commit, rootState}) {
            const data = await forceNewsService.getAmsCustomerInfo();
            commit(TYPE.SET_AMS_CUSTOMER_INFO, {data, rootState})
        },
        async [TYPE.INIT_FORCE_NEWS]({dispatch}) {
            await dispatch(TYPE.GET_SYSTEM_CACHE);
            await dispatch(TYPE.GET_AMS_CUSTOMER_INFO)
        },
        async [TYPE.GET_VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS]({commit}, payload) {
            commit(TYPE.VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS, payload);
        },
        [TYPE.SET_REMAIN_FORCE_NEWS_LIST]({commit}, payload) {
            commit(TYPE.SET_REMAIN_FORCE_NEWS_LIST, payload);
        },
    },
    getters: {
        listPrefecture(state) {
            const {systemCache} = state;
            let result = [];
            let listPrefecture = [];
            if (systemCache) {
                for (const index in systemCache.mapPrefecture) {
                    listPrefecture.push({value: systemCache.mapPrefecture[index]});
                }
                if (listPrefecture.length > 0) {
                    for (const prefecture in listPrefecture) {
                        if (listPrefecture[prefecture].value == 'nts.prefecture.default') {
                            result.push({key: "", value: i18n.t(listPrefecture[prefecture].value)});
                        } else {
                            result.push({
                                key: ServiceUtils.convertHalfwidthToFullwidthReturn(i18n.t(listPrefecture[prefecture].value)),
                                value: i18n.t(listPrefecture[prefecture].value)
                            });
                        }
                    }
                }

            }
            return result;
        },
        amsWhitelabelConfigInfo(state) {
            if (state.systemCache) {
                return state.systemCache.amsWhitelabelConfigInfo
            }
            return [];
        },
        mapGroupFieldAmsCustomer(state){
            if (state.systemCache) {
                return state.systemCache.mapGroupFieldAmsCustomer
            }
            return null;
        },
        mapReportTemplateCache(state) {
            if (state.systemCache) {
                return state.systemCache.mapReportTemplateCache
            }
            return null;
        },
        getForceNewsCustomerInfoView(state){
            if (state.customerInfoView) {
                return state.customerInfoView;
            }
            return null;
        }
    }

};


const initInput = (state, payload) => {
    const {data, rootState} = payload;
    state.customerInfoResponse = data;
    state.SUPPORT_DOCUMENT_URL = data.supportDocumentUrl;
    state.SUPPORT_DOMINATOR_URL = data.supportDominatorUrl;
    state.SUPPORT_FORM_URL = data.supportFormUrl;
    state.NEW_UPLOAD_DOCUMENT_URL = data.newDocumentUploadUrl;
    state.customerInfoView = data.amsCustomerInfoView;
    if (state.customerInfoView.corporationType === IConstants.CUSTOMER_TYPE.INDIVIDUAL) {
        state.isCorporation = false;
        state.formName = "edit_individual";
    } else {
        state.isCorporation = true;
        state.formName = "edit_corporation";
    }

    const boLossMaxAmount = state.customerInfoView.boLossMaxAmount;
    if (boLossMaxAmount && boLossMaxAmount != "") {
        const amt = boLossMaxAmount.replace(/[^0-9.]/g, '');
        state.customerInfoView.boLossMaxAmount = floor(amt)+'';
    }
    const {customerInfoView} = state;
    let input = {};
    for (const fieldAmsCustomer in customerInfoView) {
        if (fieldAmsCustomer == "investmentView" || fieldAmsCustomer == "cryptInvestmentPurposeView" || fieldAmsCustomer == "boInvestmentPurposeView") {
            input["amsCustomerDetail." + fieldAmsCustomer] = customerInfoView[fieldAmsCustomer];
        } else if (fieldAmsCustomer == "additionalEmail") {
            input["amsCustomerDetail." + fieldAmsCustomer] = customerInfoView[fieldAmsCustomer];
            if (customerInfoView[fieldAmsCustomer]) {
                state.hasAdditionEmail = true;
            }
        } else if (fieldAmsCustomer == "picPerfecture" || fieldAmsCustomer == "prefecture") {
            input["amsCustomerDetail." + fieldAmsCustomer] = ServiceUtils.convertHalfwidthToFullwidthReturn(customerInfoView[fieldAmsCustomer]);
        } else {
            input["amsCustomerDetail." + fieldAmsCustomer] = customerInfoView[fieldAmsCustomer];
        }
    }

    // 2Fa vue add
    input['amsCustomerDetail.verifyCode'] = "";

    //Update password add
    input['amsCustomerDetail.newPassword'] = "";
    input['amsCustomerDetail.currentPassword'] = "";
    input['amsCustomerDetail.reTypePassword'] = "";

    const listForceNewsInfo = JSON.parse(JSON.stringify(rootState)).news.listForceNewsInfo;
    if (!isEmpty(listForceNewsInfo)) {
        listForceNewsInfo.map((item, index) => {
            const newInput = {messageId: item.messageId, ...input};
            Vue.set(state.inputArr, index, newInput);
            validateSelfAssetAndBoMaxLoss(state, item.messageId);
            state.remainForceNewsList.push(item.messageId);
        })
    }else {
        console.error("listForceNewsInfo is empty")
    }
};

const validateSelfAssetAndBoMaxLoss = (state, message) => {
    validateBoMaxLossAmount(state, message);
    invalidSelfAssets(state, message);
    updateCboHedgeAmount(state, message);
};

const validateBoMaxLossAmount = (state, messageId) => {
    const inputArr = [...state.inputArr];
    const amsWhitelabelConfigInfo = JSON.parse(JSON.stringify(state.systemCache.amsWhitelabelConfigInfo));
    if (isEmpty(inputArr) || isNil(amsWhitelabelConfigInfo)) {
        return;
    }
    let messageBoMaxLossAmount = '';
    let validBoMaxLoss = true;
    const inputIndex = findIndex(inputArr, item => (item.messageId == messageId));
    const input = inputArr[inputIndex];
    const value = input['amsCustomerDetail.boLossMaxAmount']
    const boMaxLossAmount = !isEmpty(value) ? value.replace(/[^0-9]/g, '') : '';
    if (boMaxLossAmount != "") {
        const selfAssets = input['amsCustomerDetail.investmentAmount'];
        if (selfAssets != -1) {
            const amsMaxLossAmountValue = find(amsWhitelabelConfigInfo, item => (item.asserts == selfAssets)).value;
            const numberBoMaxLossAmount = Number(boMaxLossAmount.replace(/,/g, ""));
            if (boMaxLossAmount && numberBoMaxLossAmount > Number(amsMaxLossAmountValue) || (boMaxLossAmount && numberBoMaxLossAmount <= 0)) {
                messageBoMaxLossAmount = i18n.t(ServiceUtils.getMessageMaxAmountError(amsMaxLossAmountValue));
                validBoMaxLoss = false;
            }
        }
    }
    else {
        validBoMaxLoss = true;
    }
    const newInput = {...input, validBoMaxLoss, messageBoMaxLossAmount};
    Vue.set(state.inputArr, inputIndex, newInput);
};

const invalidSelfAssets = (state, messageId) => {
    const inputArr = [...state.inputArr];
    const amsWhitelabelConfigInfo = JSON.parse(JSON.stringify(state.systemCache.amsWhitelabelConfigInfo));
    if (isEmpty(inputArr) || isNil(amsWhitelabelConfigInfo)) {
        return;
    }

    let errorMessageSelfAssets = '';
    let isInvalidSelfAssets = false;
    let invalidForBoMaxLoss = false;

    let errorMessageAboutBoHedgeAmount = '';
    let invalidForBoHedgeAmount = false;

    const inputIndex = findIndex(inputArr, item => (item.messageId == messageId));
    const input = inputArr[inputIndex];
    const boMaxloss = input['amsCustomerDetail.boLossMaxAmount'] || '';
    const boMaxLossAmount = boMaxloss.replace(/[^0-9.]/g, '');

    const selfAssets = input['amsCustomerDetail.investmentAmount'];
    if (selfAssets != -1) {
        const amsMaxLossAmountValue = find(amsWhitelabelConfigInfo, item => (item.asserts == selfAssets)).value;
        if (isNumber(boMaxLossAmount)) {
            if (boMaxLossAmount <= 0 || boMaxLossAmount > amsMaxLossAmountValue) {
                errorMessageSelfAssets = i18n.t(ServiceUtils.getMessageMaxAmountError(amsMaxLossAmountValue));

                isInvalidSelfAssets = true;
                invalidForBoMaxLoss = true;
            }
        }

        if (input['amsCustomerDetail.boInvestmentPurposeView'].boPurposeHedgeFlg == 1) {
            if (input["amsCustomerDetail.boPurposeHedgeAmount"] > input["amsCustomerDetail.investmentAmount"]) {
                let errorMessage = '';
                if (state.isCorporation) {
                    errorMessage = i18n.t('profile.error.sefl_assets.hedge_amount_conflick_corp');
                } else {
                    errorMessage = i18n.t('profile.error.sefl_assets.hedge_amount_conflick_indv');
                }
                errorMessageSelfAssets = errorMessage;
                errorMessageAboutBoHedgeAmount = errorMessage;

                isInvalidSelfAssets = true;
                invalidForBoHedgeAmount = true;
            }
        }
    }

    const newInput = {...input, isInvalidSelfAssets, errorMessageSelfAssets,
        invalidForBoMaxLoss, invalidForBoHedgeAmount, errorMessageAboutBoHedgeAmount};
    Vue.set(state.inputArr, inputIndex, newInput);
};

const updateCboHedgeAmount = (state, messageId) => {
    const inputArr = [...state.inputArr];
    const amsWhitelabelConfigInfo = JSON.parse(JSON.stringify(state.systemCache.amsWhitelabelConfigInfo));
    if (isEmpty(inputArr) || isNil(amsWhitelabelConfigInfo)) {
        return;
    }
    const inputIndex = findIndex(inputArr, item => (item.messageId == messageId));
    const input = inputArr[inputIndex];
    var selfAssets = input['amsCustomerDetail.investmentAmount'];
    const listFinalAssetsWithHeader = [];
    for (var finalAssets in listFinalAssets) {
        if (listFinalAssets[finalAssets].key <= selfAssets) {
            listFinalAssetsWithHeader.push(listFinalAssets[finalAssets]);
        }
    }
    listFinalAssetsWithHeader.unshift({
        "key": "", value: 'profile.label.please_select'
    });
    const newInput = {...input, listFinalAssetsWithHeader};
    Vue.set(state.inputArr, inputIndex, newInput);
};


export default moduleNews;
